// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__zdKgT","lds-ripple":"Loader_lds-ripple__0Aeo5","center":"Loader_center__EmtQO"};